/**
 * @file Parses a decimal string, as the analytics service and goal documents
 * write money, into an exact `AnalyticsFraction` of `digits / 10^scale`.
 * Consumers: every Overview figure and `goalProgress`. Only `-?digits(.digits)?`
 * parses; an exponent, a plus sign, a bare point or an empty string answers
 * `undefined`, so a malformed cell is caught rather than read as a number.
 */
import type { AnalyticsFraction } from './AnalyticsFraction.types';

const DECIMAL = /^(-?)(\d+)(?:\.(\d+))?$/;

export const analyticsDecimalFraction = (
  decimal: string,
): AnalyticsFraction | undefined => {
  const match = DECIMAL.exec(decimal);
  if (match === null) return undefined;
  const [, sign, whole, places = ''] = match;
  const magnitude = BigInt(`${whole}${places}`);
  return {
    numerator: sign === '-' ? -magnitude : magnitude,
    denominator: 10n ** BigInt(places.length),
  };
};
